import type { IMassGridCapacitiesDto } from "types/capacity";
import type { IUnloadCapacityDto } from "types/unload-capacity";
import Fetch from "utils/fetch";

// Unload Capacity Services
export const saveUnloadCapacityAsync = async (request: IUnloadCapacityDto[]) => {
  return await Fetch.post(`/unload-capacities/create-unload-capacity`, request);
};

export const GetUnloadByBusinessUnitAndFamilyAsync = (
  dateFrom?: string,
  dateTo?: string,
  businessUnitId?: number,
  familyId?: number
) =>
  Fetch.get(
    `/unload-capacities/by-businessunit-family?businessUnitId=${businessUnitId}&familyId=${familyId}&dateFrom=${dateFrom}&dateTo=${dateTo}`
  ).then(({ data }) => data);

export const GetUnloadByBusinessUnitAndMaterialGroupAsync = (
  dateFrom?: string,
  dateTo?: string,
  businessUnitId?: number,
  familyId?: number
) =>
  Fetch.get(
    `/unload-capacities/by-businessunit-materialgroup?businessUnitId=${businessUnitId}&materialGroupId=${familyId}&dateFrom=${dateFrom}&dateTo=${dateTo}`
  ).then(({ data }) => data);

export const SaveUnloadCapacitiesInMass = (body: IMassGridCapacitiesDto) =>
  Fetch.post("/unload-capacities/create-mass-unload-capacities", body);
